/** Warmteo wordmark — používá oficiální PNG logo z /public/warmteo-logo.png.
 *  Asset je 340×130 (gold transparent). `size` prop = výška v px,
 *  šířka se škáluje proporčně. */

interface WordmarkProps {
  size?: number;
  /** vrátí grayscale-černou variantu (např. pro tisk / monoflow) */
  mono?: boolean;
  /** alt text — defaultně "Warmteo" */
  alt?: string;
}

export function Wordmark({ size = 22, mono = false, alt = "Warmteo" }: WordmarkProps) {
  return (
    <img
      src="/warmteo-logo.png"
      alt={alt}
      style={{
        height: size,
        width: "auto",
        display: "inline-block",
        verticalAlign: "middle",
        filter: mono ? "grayscale(1) brightness(0.4)" : undefined,
      }}
      draggable={false}
    />
  );
}
